export type IntegrationEventType = "Organization" | "Shipment" | "Invoice" | "Cost" | "Payable";

export const integrationEventAbbreviations: Record<IntegrationEventType, string> = {
  Organization: "org",
  Shipment: "shp",
  Invoice: "inv",
  Cost: "cst",
  Payable: "pay",
};

export function toIntegrationCode(value: string) {
  return value.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function createIntegrationEventCode(integrationCode: string, eventType: IntegrationEventType, sequence: number) {
  const safeSequence = Math.max(1, Math.trunc(sequence));
  return `${integrationCode}-${integrationEventAbbreviations[eventType]}-${String(safeSequence).padStart(3, "0")}`;
}
